export default "/images/51636e82983b0ec836fa40b32211d301.avif";